export enum PdfStatusEnum {
  EMPTY = 0,
  EXIST = 1,
}
